export type PartnerText = string | { en?: string; fr?: string };
export const partnerText = (text: PartnerText | null | undefined, locale: string, fallback = "") =>
  typeof text === "string" ? text || fallback : text?.[locale === "fr" ? "fr" : "en"] || text?.en || text?.fr || fallback;

export interface PartnerPageContent {
  hero_title?: PartnerText;
  hero_description?: PartnerText;
  benefits?: { title: PartnerText; description: PartnerText; icon: "doctor" | "billing" | "users" | "globe" | "monitor" | "support"; is_visible: boolean }[];
  faqs?: { question: PartnerText; answer: PartnerText; is_visible: boolean }[];
}

export interface ServiceCategory {
  category: string;
  title: string;
  description: string;
  buttonLabel: string;
  displayOrder: number;
  image?: string;
  features?: string[];
  translations?: Record<string, { title?: string; description?: string; button_label?: string; features?: string[] }>;

}

export interface PartnerProfile {
  id: string;
  name: string;
  slug: string;
  colorPalette: string[];
  accentColor?: string;
  logo: string | null;
  serviceCategories: ServiceCategory[];
  description?: string;
  briefDescription?: string;
  galleryImages?: string[];
  contactPhone?: string;
  contactEmail?: string;
  whatsappNumber?: string;
  operatingHours?: string;
  accreditations?: string[];
  pageContent?: PartnerPageContent;

}
